<template>
  <!-- Sidebar -->
  <div class="ew-sidebar">
    <div class="ew-sidebar__top">
      <div class="ew-sidebar__header">
        <img class="ew-sidebar__logo" src="@/assets/images/logo-ew.png" alt="Logo">
      </div>

      <div class="ew-wallet">
        <router-link
          class="ew-wallet__link"
          :class="{ 'is-current': isActive('prepaids') }"
          to="/prepaids"
        >
          <span class="ew-wallet__label">Saldo en monedero</span>
          <span class="ew-wallet__value">{{ formatMXN(total_monedero) }}</span>
        </router-link>
        <router-link
          class="ew-wallet__action"
          to="/prepaid/new"
          aria-label="Agregar saldo al monedero"
        >
          <ph-icon name="plus" />
        </router-link>
      </div>

      <nav class="ew-menu" aria-label="Principal">
        <ul class="ew-menu__list">
          <li @click="setActive('dashboard')">
            <router-link
              class="ew-menu__item"
              :class="{ 'is-current': isActive('dashboard') }"
              :aria-current="isActive('dashboard') ? 'page' : null"
              to="/dashboard"
            >
              <span class="ew-menu__icon"><ph-icon name="squares-four" :weight="iconWeight('dashboard')" /></span>
              <span class="ew-menu__label">Dashboard</span>
            </router-link>
          </li>
          <li @click="setActive('shipments')">
            <router-link
              class="ew-menu__item"
              :class="{ 'is-current': isActive('shipments') }"
              :aria-current="isActive('shipments') ? 'page' : null"
              to="/shipments"
            >
              <span class="ew-menu__icon"><ph-icon name="package" :weight="iconWeight('shipments')" /></span>
              <span class="ew-menu__label">Mis Envíos</span>
            </router-link>
          </li>
          <li @click="setActive('integrations')">
            <router-link
              class="ew-menu__item"
              :class="{ 'is-current': isActive('integrations') }"
              :aria-current="isActive('integrations') ? 'page' : null"
              to="/integrations"
            >
              <span class="ew-menu__icon"><ph-icon name="puzzle-piece" :weight="iconWeight('integrations')" /></span>
              <span class="ew-menu__label">Integraciones</span>
            </router-link>
          </li>
          <li @click="setActive('prepaids')">
            <router-link
              class="ew-menu__item"
              :class="{ 'is-current': isActive('prepaids') }"
              :aria-current="isActive('prepaids') ? 'page' : null"
              to="/prepaids"
            >
              <span class="ew-menu__icon"><ph-icon name="wallet" :weight="iconWeight('prepaids')" /></span>
              <span class="ew-menu__label">Monedero</span>
            </router-link>
          </li>
          <li @click="setActive('addresses')">
            <router-link
              class="ew-menu__item"
              :class="{ 'is-current': isActive('addresses') }"
              :aria-current="isActive('addresses') ? 'page' : null"
              to="/addresses"
            >
              <span class="ew-menu__icon"><ph-icon name="address-book" :weight="iconWeight('addresses')" /></span>
              <span class="ew-menu__label">Direcciones</span>
            </router-link>
          </li>
          <li @click="setActive('payments')">
            <router-link
              class="ew-menu__item"
              :class="{ 'is-current': isActive('payments') }"
              :aria-current="isActive('payments') ? 'page' : null"
              to="/payments"
            >
              <span class="ew-menu__icon"><ph-icon name="credit-card" :weight="iconWeight('payments')" /></span>
              <span class="ew-menu__label">Métodos de pago</span>
            </router-link>
          </li>
          <li @click="setActive('overweight')">
            <router-link
              class="ew-menu__item"
              :class="{ 'is-current': isActive('overweight') }"
              :aria-current="isActive('overweight') ? 'page' : null"
              to="/overweight"
            >
              <span class="ew-menu__icon"><ph-icon name="scales" :weight="iconWeight('overweight')" /></span>
              <span class="ew-menu__label">Sobrepesos</span>
            </router-link>
          </li>
          <li v-if="isAdmin" @click="setActive('general_report')">
            <router-link
              class="ew-menu__item"
              :class="{ 'is-current': isActive('general_report') }"
              :aria-current="isActive('general_report') ? 'page' : null"
              to="/general_report"
            >
              <span class="ew-menu__icon"><ph-icon name="chart-line-up" :weight="iconWeight('general_report')" /></span>
              <span class="ew-menu__label">Reporte General</span>
            </router-link>
          </li>
          <li v-if="isAdmin" @click="setActive('overweight_report')">
            <router-link
              class="ew-menu__item"
              :class="{ 'is-current': isActive('overweight_report') }"
              :aria-current="isActive('overweight_report') ? 'page' : null"
              to="/overweight_report"
            >
              <span class="ew-menu__icon"><ph-icon name="chart-bar" :weight="iconWeight('overweight_report')" /></span>
              <span class="ew-menu__label">Reporte Sobrepesos</span>
            </router-link>
          </li>
          <li v-if="isAdmin" @click="setActive('users')">
            <router-link
              class="ew-menu__item"
              :class="{ 'is-current': isActive('users') }"
              :aria-current="isActive('users') ? 'page' : null"
              to="/users"
            >
              <span class="ew-menu__icon"><ph-icon name="users" :weight="iconWeight('users')" /></span>
              <span class="ew-menu__label">Usuarios</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>

    <div class="ew-sidebar__bottom">
      <ul class="ew-menu__list">
        <li>
          <router-link class="ew-menu__item" to="/contactanos">
            <span class="ew-menu__icon"><ph-icon name="question" /></span>
            <span class="ew-menu__label">Centro de ayuda</span>
          </router-link>
        </li>
        <li @click="logout()">
          <router-link
            class="ew-menu__item"
            to="javascript:;"
            :event="disabled ? '' : 'click'"
          >
            <span class="ew-menu__icon"><ph-icon name="sign-out" /></span>
            <span class="ew-menu__label">Cerrar sesión</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import commons from '../commons'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import PhIcon from './icons/PhIcon'
import { formatMXN } from '../commons/currency'

export default {
  name: 'Dashboard',
  data () {
    return {
      disabled: true,
      isAdmin: false,
      total_monedero: 0,
    }
  },
  created () {
    this.setItemActive('dashboard')
    axios
    .get(`${commons.apiURL}/api/v1/users/${localStorage.getItem('ew-user-id')}`)
    .then(response => {
      if (response.data) {
        this.isAdmin = response.data.rol == 'admin' ? true : false
        console.log(response.data.rol)
      }
    });
    setTimeout(() => {
      this.getTotalAmountPrepaids();
    }, 1500)

  },
  methods: {
     formatMXN,
     logout(){
      this.isLoging = false
      localStorage.clear()
      this.$router.push('/signin')
    },
    isActive(item){
      return this.itemActive === item
    },
    setActive(item){
      this.setItemActive(item)
    },
    // Segunda señal (además del fondo) de que un item está activo: el icono
    // pasa de trazo (regular) a relleno (fill). Ayuda a quien no distingue
    // bien el color, y es gratis con Phosphor.
    iconWeight(item){
      return this.isActive(item) ? 'fill' : undefined
    },
    getTotalAmountPrepaids () {
      this.total_monedero = 0;
      axios
      .get(`${commons.apiURL}/api/v1/prepaid/getTotalAmount/${localStorage.getItem('ew-user-id')}`)
      .then(response => {
        this.total_monedero = parseFloat(response.data.total_amount)
      })
      .catch(error => {
        console.error(error)
      })
    },
    ...mapMutations(['setItemActive'])
  },
  computed: {
    ...mapGetters(['user', 'itemActive'])

  },
  components: {
    PhIcon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/sidebar-tokens";

.ew-sidebar {
  @include sidebar-tokens;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  background: #fff;
  font-family: var(--sb-font);
}

.ew-sidebar__top {
  flex: 1 1 auto;
  min-height: 0; // permite que .ew-menu (adentro) sea lo único que haga scroll
  display: flex;
  flex-direction: column;
}

.ew-sidebar__bottom {
  flex: 0 0 auto;
  padding: 0.5rem var(--sb-h-padding) 1rem;
}

.ew-sidebar__header {
  flex: 0 0 auto;
  height: var(--sb-header-height);
  display: flex;
  align-items: center;
  padding: 0 var(--sb-h-padding);
}

.ew-sidebar__logo {
  width: 9.7rem;
  height: auto;
  display: block;
}

/* Tarjeta de saldo del monedero -------------------------------------------- */
.ew-wallet {
  flex: 0 0 auto;
  margin: 0 var(--sb-h-padding) 1rem;
  padding: var(--sb-wallet-padding);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  background: var(--sb-surface-muted);
  border: 1px solid var(--sb-border);
  border-radius: var(--sb-wallet-radius);
}

.ew-wallet__link {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
  color: var(--sb-navy-secondary);
  text-decoration: none;
  border-radius: 0.4rem;

  &:hover,
  &.is-current {
    color: var(--sb-navy);
    text-decoration: none;
  }

  &:focus-visible {
    outline: 3px solid var(--sb-accent);
    outline-offset: 3px;
  }
}

.ew-wallet__label {
  font-size: 0.7rem;
  font-weight: var(--sb-item-weight);
  color: var(--sb-muted);
}

.ew-wallet__value {
  font-family: var(--sb-mono);
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--sb-navy);
}

.ew-wallet__action {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--sb-wallet-action-size);
  height: var(--sb-wallet-action-size);
  border-radius: 999px;
  background: var(--sb-accent);
  color: var(--sb-on-accent);

  svg { width: 1.15rem; height: 1.15rem; }

  &:hover { background: var(--sb-accent-hover); }

  &:focus-visible {
    outline: 3px solid var(--sb-accent);
    outline-offset: 3px;
  }
}

/* Navegación ----------------------------------------------------------------- */
.ew-menu {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 0.25rem var(--sb-h-padding) 0.5rem;
}

.ew-menu__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.ew-menu__item {
  display: flex;
  align-items: center;
  gap: var(--sb-label-gap);
  min-height: var(--sb-item-min-height);
  padding: 0 0.75rem;
  border-radius: var(--sb-item-radius);
  color: var(--sb-navy-secondary);
  font-family: var(--sb-font);
  font-size: var(--sb-item-size);
  font-weight: var(--sb-item-weight);
  text-decoration: none;
  transition: background-color .15s ease, color .15s ease;

  &:hover {
    background: var(--sb-surface-muted);
    color: var(--sb-navy);
    text-decoration: none;
  }

  &.is-current {
    background: var(--sb-active-bg);
    color: var(--sb-active-text);
    font-weight: var(--sb-item-weight-active);
  }

  &:focus-visible {
    outline: 3px solid var(--sb-accent);
    outline-offset: 3px;
  }
}

.ew-menu__icon {
  flex-shrink: 0;
  width: var(--sb-icon-box);
  height: var(--sb-icon-box);
  display: flex;
  align-items: center;
  justify-content: center;

  svg { width: var(--sb-icon-size); height: var(--sb-icon-size); }
}

.ew-menu__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue